// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "*[data-v-1a7a6c16] {\n  font-size: 14px;\n}\n.checkbox[data-v-1a7a6c16] {\n  width: 18px;\n  height: 18px;\n  border: 2px solid #747474;\n  border-radius: 2px;\n}\n.checkbox--checked[data-v-1a7a6c16] {\n  border-color: #82b1ff;\n  background: #82b1ff;\n}\n.checkbox--checked > i.v-icon[data-v-1a7a6c16] {\n  color: #fff !important;\n  margin-left: -1px;\n  margin-bottom: 3px;\n}\n.checkbox--not-checked[data-v-1a7a6c16] {\n  background: inherit;\n}", ""]);
// Exports
module.exports = exports;
